module.exports = __webpack_public_path__ + "static/media/dgd.b6eb2ad6.png";